/**
 * @generated SignedSource<<6738d5f08b9e24bcae5d7625d778079f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScaffoldQuery$variables = {
  targetPath: string;
};
export type ScaffoldQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AnnouncementFragment" | "HeaderFragment">;
};
export type ScaffoldQuery = {
  response: ScaffoldQuery$data;
  variables: ScaffoldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetPath"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "targetPath",
    "variableName": "targetPath"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScaffoldQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "HeaderFragment"
      },
      {
        "args": (v1/*:: as any*/),
        "kind": "FragmentSpread",
        "name": "AnnouncementFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ScaffoldQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageThumbnail",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Announcement",
        "kind": "LinkedField",
        "name": "announcementByTargetPath",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetPath",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expiresAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "badge",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "kind",
            "storageKey": null
          },
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fd382317d94cf193e42a5aadca0d309a",
    "id": null,
    "metadata": {},
    "name": "ScaffoldQuery",
    "operationKind": "query",
    "text": "query ScaffoldQuery(\n  $targetPath: String!\n) {\n  ...HeaderFragment\n  ...AnnouncementFragment_3uirqb\n}\n\nfragment AnnouncementFragment_3uirqb on Query {\n  announcementByTargetPath(targetPath: $targetPath) {\n    targetPath\n    expiresAt\n    message\n    active\n    badge\n    kind\n    id\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment HeaderFragment on Query {\n  viewer @ifAllowed {\n    __typename\n    id\n    ...UserMenuFragment\n  }\n}\n\nfragment UserMenuFragment on User {\n  id\n  displayName\n  username\n  ...EntityProfilePicFragment_49kWkb\n}\n"
  }
};
})();

(node as any).hash = "3580076c010fabe27e26b03533f88a48";

export default node;
